// extracted by mini-css-extract-plugin
module.exports = {"adminFeeInfoButton":"admin-fee-button_adminFeeInfoButton__Q1bL4","adminFeeInfoButtonBreak":"admin-fee-button_adminFeeInfoButtonBreak__lX1Ga"};